export default __webpack_public_path__ + "static/media/20200724_130659.98d6dbbc.JPG";